import templateUrl from "emun.prospect/prospect-profile.htm";
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import prospectConfig from "emun.prospect/prospect.config";
import modals from "webmodals/modals";
import activityConfig from "emun.activity/activity.config";

export class ProspectProfileController {
  constructor(prospectPrompt, $window, Lightbox) {
    let $ctrl = this;
    basicController($ctrl);
    $ctrl.prompt = prospectPrompt;
	  $ctrl.prospectConfig = prospectConfig;
	  $ctrl.activityConfig = activityConfig;
    this.openMap = function () {
      var location =
        $ctrl.prospect.address +
        " " +
        $ctrl.prospect.city +
        ", " +
        $ctrl.prospect.state +
        " " +
        $ctrl.prospect.zip;
      $window.open("http://www.google.com/maps/place/" + location);
    };

    let options = {
      url: "QueryProspects.json?Id=" + $ctrl.prospectId,
      pageSize: 15,
      orderBy: "CompanyName",
      autoLoad: true,
      append: false,
      onLoaded: function (args) {
        $ctrl.prospect = args.first;
        $ctrl.$state.current.customTitle = $ctrl.prospect.companyName;
      },
    };
    $ctrl.query = new AutoQuery(options);
    var bus = ($ctrl.bus = $ctrl.query.bus);

    $ctrl.mediaQuery = new AutoQuery({
      url: "QueryMedia.json?realm=Prospect",
      tagCriteria: {
        ProspectId: $ctrl.prospectId,
      },
      autoLoad: true,
      onLoaded: function (args) {
        $ctrl.images = [];
        args.results.forEach(function (arg) {
          $ctrl.images.push({
            thumbUrl: arg.url,
            url: arg.url,
          });
        });
      },
    });
    $ctrl.openLightboxModal = function (index) {
      Lightbox.openModal($ctrl.images, index);
    };
  }
  delete(prospect) {
    let $ctrl = this;
    return modals
      .confirm("Are you sure?", "Delete Prospect")
      .result.then(function () {
        $ctrl.bus.send("DeleteProspect", prospect);
        $ctrl.$state.transitionTo("prospect.list");
      });
  }
  edit() {
    let $ctrl = this;
    return $ctrl.prompt.edit($ctrl.prospect).then(function () {
      $ctrl.load();
      $ctrl.$emit("prospectSaved");
    });
  }
  load() {
    let $ctrl = this;
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }
  setStatus(status) {
    let $ctrl = this;
    $ctrl.$emit("prospectSaved", this);
  }
  toggleHot() {
    let $ctrl = this;
    $ctrl.prospect.hot
      ? ($ctrl.prospect.hot = false)
      : ($ctrl.prospect.hot = true);
    $ctrl.bus
      .send("UpdateProspect.json", $ctrl.prospect)
      .then(function (response) {
        $ctrl.$emit("prospectSaved", this);
      });
  }
  upload($files) {
    const $ctrl = this;
    if ($files && $files.length) {
      let req = {
        request: {
          realm: "Prospect",
          tags: {
            ProspectId: $ctrl.prospect.id,
          },
        },
        files: $files,
        urls: [],
      };

      $ctrl.bus.upload("CreateMedia.json", req).then((res) => {
        $ctrl.mediaQuery.load(true);
        //let media = res.data.media.map(m => new Media(m));
        //$ctrl.close(media);
      });
    }
  }
}

export default {
  bindings: {
    prospectId: "@",
  },
  require: {
    container: "^prospectContainer",
  },
  controller: ProspectProfileController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
